import moment from 'moment'

export const themeConfig = ($mdThemingProvider, $mdDateLocaleProvider) => {
  'ngInject'

  // define palette
  $mdThemingProvider.definePalette('documentus', {
    50: 'E3E8F2',
    100: 'BAC6DE',
    200: '8CA0C8',
    300: '5E7AB2',
    400: '3C5EA2',
    500: '194191',
    600: '163B89',
    700: '12327E',
    800: '0E2A74',
    900: '081C62',
    A100: '94A7FF',
    A200: '617DFF',
    A400: '2E52FF',
    A700: '143DFF',
    contrastDefaultColor: 'light',
    contrastDarkColors: ['50', '100', '200', 'A100', 'A200'],
    contrastLightColors: ['300', '400', '500', '600', '700', '800', '900', 'A400', 'A700'],
  })

  // define theme
  $mdThemingProvider
    .theme('default')
    .primaryPalette('documentus')
    .accentPalette('amber')
    .warnPalette('red')
    .backgroundPalette('grey', {
      default: 'A100',
      'hue-1': '100',
      'hue-2': '200',
      'hue-3': '300',
    })

  // set date format
  $mdDateLocaleProvider.formatDate = (date) => (date ? moment(date).format('DD.MM.YYYY') : '')
  // fix md datepicker issues, when date is manually entered
  $mdDateLocaleProvider.parseDate = (dateString) => {
    let m = moment(dateString, 'DD.MM.YYYY', true)
    return m.isValid() ? m.toDate() : new Date(NaN)
  }
}



// WEBPACK FOOTER //
// ./app/themes/documentus.theme.js